// removed by extract-text-webpack-plugin
module.exports = {"studentsNavModal":"src-components-StudentsNavModal----StudentsNavModal-module---studentsNavModal---ScSMp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StudentsNavModal/StudentsNavModal.module.scss
// module id = 125
// module chunks = 29990747609436 213534597649335